// toggle-button.component.ts
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-toggle-button',
    templateUrl: './toggle-button.component.html',
    styleUrls: ['./toggle-button.component.css'],
})
export class ToggleButtonComponent implements OnChanges {
    @Input() isGridView = true;
    @Output() viewChanged = new EventEmitter<string>();

    ngOnChanges(changes: SimpleChanges) {
        if (changes['isGridView']) {
            this.isGridView = changes['isGridView'].currentValue;
        }
    }

    selectView(view: string) {
        this.isGridView = view === 'grid';
        this.viewChanged.emit(view);
    }
}
